import '../scss/style.scss';
import { nodeListForEach } from './addons/polyfills';
import ScrollTo from './components/Scrollto';
import ModalControler from './components/modal/ModalControler';
import FormInputEventsJs from './components/FormInputEvents';
import Forms from './components/Forms';
import StoriesSlider from './components/StoriesSlider';
import ClientsSlider from './components/ClientsSlider';
import PlansSlider from './components/PlansSlider';
import Cookie from './components/Cookie';
import Mobile from './components/Mobile';
import InView from './components/InView';
import Paralax from './components/Paralax';
import Kringel from './components/Kringel';
import FeaturesSlider from './components/FeaturesSlider';
import BackToTopColor from './components/BackToTopColor';
import VideoLoad from './components/VideoLoad';
import VideoPlay from './components/VideoPlay';
import Calculator from './components/calculator/Calculator';
import TabControler from './components/tab/TabControler';
import CopyUrl from './components/CopyUrl';
import Toggler from './components/Toggler';
import HeroImages from './components/heroImages';
import Faq from './components/Faq';
import HeaderScroll from './components/HeaderScroll';
import BestCharts from './components/BestCharts';
import BestNav from './components/BestNav';

nodeListForEach();

const inits = (): void => {
  new ScrollTo('[data-scrollto]');
  /*
   * `initRecaptcha()` calls `grecaptcha.render()` directly, so it needs
   * Google's script to be there — it stays on `load` while the rest of the
   * form moved earlier. A throw here would take out every init below it.
   */
  Forms.initRecaptcha();
  StoriesSlider.init();
  PlansSlider.init();
  Cookie.init();
  InView.init();
  // Paralax.init();
  Kringel.init();
  FeaturesSlider.init('.features__slider');
  BackToTopColor.init();
  ClientsSlider.init();
  VideoLoad.init();
  VideoPlay.init();
  CopyUrl.init();
  Toggler.init();
  HeroImages.initHeroImages();
  Faq.init();
  HeaderScroll.init();
  BestCharts.init();
  BestNav.init();
  new Calculator('.js-calculator');
  new TabControler();
};

const onScroll = (e: Event): void => {};

const onResize = (e: Event): void => {
  onScroll(e);
};

const onLoad = (e: Event): void => {
  document.body.classList.remove('body-loading');
  document.body.classList.add('body-loaded');
  inits();
  onResize(e);
};

/*
 * Everything a visitor can touch the moment the page is painted binds as soon
 * as the DOM is parsed, ahead of the rest.
 *
 * `inits()` runs on `window load`, which waits for every image, the homepage
 * video and the third-party scripts — so the burger, the "Try it free" button
 * and the contact form are all on screen and clickable long before their
 * handlers exist, and anything done in that window silently fails. Measured on
 * the homepage at `readyState === "interactive"`: the burger is in the DOM and
 * a real click leaves `.drawer` closed with no `is-active` on the burger. The
 * forms are worse than inert there — with no submit handler attached the
 * browser natively posts to the current URL and the page just re-renders.
 *
 * Order inside here matters: `inputsEvents()` builds the custom selects that
 * `SimpleModal.cbOnModalOpen()` writes the chosen plan into, so it has to run
 * before the modals are constructed.
 *
 * What stays on `load` and why: the sliders, the hero animation and the
 * parallax all measure elements whose size depends on images having loaded,
 * and `Forms.initRecaptcha()` needs Google's script (see `inits()`).
 * `Mobile.init()` still assigns `window.onscroll` before `HeaderScroll` adds
 * its own scroll listener, which is the order those two rely on for
 * `is-shrinked`.
 */
const earlyInits = (): void => {
  Mobile.init();
  FormInputEventsJs.inputsEvents();
  Forms.initForm();
  // Kept as an assignment, exactly as it was inside `inits()`, so the no-new
  // lint rule stays satisfied.
  const modalControler = new ModalControler();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', earlyInits);
} else {
  // The bundle is loaded at the end of <body>, but a deferred or injected
  // copy can arrive after parsing is done, where the event never fires again.
  earlyInits();
}

window.addEventListener('load', onLoad);
window.addEventListener('resize', onResize);
window.addEventListener('scroll', onScroll);
